import { Box, CircularProgress, Typography } from '@mui/material';

export const LoadingScreen = () => (
  <Box
    sx={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      backgroundColor: 'background.default',
    }}
  >
    <CircularProgress />
    <Typography variant="h6">K-UCAP</Typography>
    <Typography variant="body2" color="text.secondary">
      인증 상태를 확인하는 중...
    </Typography>
  </Box>
);
